import * as guests from '@wix/auto_sdk_events_guests';
import * as notifications from '@wix/auto_sdk_events_notifications';
import * as scheduleBookmarks from '@wix/auto_sdk_events_schedule-bookmarks';
import * as schedule from '@wix/auto_sdk_events_schedule';
import * as staffMembers from '@wix/auto_sdk_events_staff-members';
import * as categories from '@wix/auto_sdk_events_categories';
import * as forms from '@wix/auto_sdk_events_forms';
import * as orders from '@wix/auto_sdk_events_orders';
import * as ricos from '@wix/auto_sdk_events_ricos';
import * as rsvp from '@wix/auto_sdk_events_rsvp';
import * as tickets from '@wix/auto_sdk_events_tickets';
import * as ticketDefinitions from '@wix/auto_sdk_events_ticket-definitions';
import * as policies from '@wix/auto_sdk_events_policies';
import * as rsvpV2 from '@wix/auto_sdk_events_rsvp-v-2';
import * as wixEventsV2 from '@wix/auto_sdk_events_wix-events-v-2';
import * as ticketDefinitionsV2 from '@wix/auto_sdk_events_ticket-definitions-v-2';

export {
  guests,
  notifications,
  scheduleBookmarks,
  schedule,
  staffMembers,
  categories,
  forms,
  orders,
  ricos,
  rsvp,
  tickets,
  ticketDefinitions,
  policies,
  rsvpV2,
  wixEventsV2,
  ticketDefinitionsV2,
};
